<div class="dark-mode-container">
  <div
    (click)="toggleDarkmode(!isDarkMode())"
    class="sidebar-button"
    matTooltip="{{
      isDarkMode() ? ('NGX-MESSAGING.DARK-MODE.lightMode' | translate) : ('NGX-MESSAGING.DARK-MODE.darkMode' | translate)
    }}">
    <mat-icon [svgIcon]="isDarkMode() ? 'brightness' : 'moon'"></mat-icon>
  </div>
</div>
